const state = {
   currentUnloading:null,
}

export default state
